export function formatPhoneNumber(phone: string) {
  if (!phone) return '';

  const cleanedPhone = phone.replace(/[^\d+]/g, '');

  const match = cleanedPhone.match(/^(.*?)(\d{10})$/);
  if (!match) return null;

  let countryCode = match[1];
  let number = match[2];

  if (countryCode && countryCode !== '+' && countryCode.startsWith('+')) {
    countryCode = '+' + countryCode.replace(/\+/g, '');
  }

  if (!countryCode) countryCode = '';

  return `${countryCode}-${number.slice(0, 3)}-${number.slice(3, 6)}-${number.slice(6, 8)}-${number.slice(8)}`;
}
